// 仅同步当前窗口的已读状态；事件不替代服务端的本人权限校验。
import {CustomerNotice} from './notificationTarget'
export const notificationChangedEvent='customer-notifications-changed'
export const publishNotificationRead=(identity:string,id?:string,maxId?:string)=>window.dispatchEvent(new CustomEvent(notificationChangedEvent,{detail:{identity,id,maxId}}))
// 点击查看后携带本人刚读取的正文到目标页，不把正文或客户信息放入URL/本地存储。
let focus:{identity:string;notice:CustomerNotice}|null=null
export const rememberNotificationFocus=(identity:string,notice:CustomerNotice)=>{focus={identity,notice:{...notice}}}
export const takeNotificationFocus=(identity:string,id:string)=>{const saved=focus;focus=null;return saved?.identity===identity && saved.notice.id===id?saved.notice:null}
export const clearNotificationFocus=()=>{focus=null}
